export default __webpack_public_path__ + "static/media/sprockets.18bdc7e5.png";